import React, { useState } from "react";
import Arrow_Btn from "../../common_components/common_btn/arrow_btn/Arrow_Btn";
import Common_Title from "../../common_components/common_title/Common_Title";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import "./Contacts.css";
import Fullscreen_Success_Modal from "../../common_components/fullscreen_success_modal/Fullscreen_Success_Modal";
import Message_Lottie from "../../common_components/animation/message_lottie/Message_Lottie";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";

const Contacts = () => {
  const {
    register,
    control,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    console.log("Form submitted with:", data);

    const htmlFormat = ` <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #eee; border-radius: 8px; max-width: 600px; margin: auto;">
          <h2 style="color: #4CAF50; border-bottom: 2px solid #4CAF50; padding-bottom: 8px;">
            📩 New Contact Form Submission
          </h2>
          <p style="font-size: 16px; margin: 10px 0;">You’ve received a new enquiry from your website:</p>
          <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Name</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.name}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Email</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.email}</td>
            </tr>            
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Message</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.message}</td>
            </tr>
          </table>
        </div>`;

    try {
      const payload = {
        email: "info@gravitydrive.in",
        subject: "Inquiry",
        html: htmlFormat,
        key: "Profcyma",
      };

      const response = await fetch(
        "https://emailservices.hostelbliss.com:3301/common-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setShowModal(true);
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
          setShowModal(false);
        }, 3000);
      } else {
        console.error("Form submission failed:", result);
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  return (
    <section className="contact_section">
      <div className="container">
        <Common_Title pageTitle="Get in Touch" boxText="Contact us" />

        <div className="contact_grid">
          <div className="contact_info">
            <div className="info_card">
              <img
                src="/assets/images/home/contacts/big_home.png"
                alt=""
                className="bg_icon"
              />
              <div className="info_content">
                <h6 className="info_label">Address</h6>
                <p className="info_text">
                  Gravity Drive, 101,Jay Bhawani Building, oppo crystal honda
                  service center,Uttam nagar, bavdhan, Pin 411021.
                </p>
              </div>
              <div className="icon_circle">
                <img
                  src="/assets/images/home/contacts/home.png"
                  alt="Location"
                  className="info_icon_img"
                />
              </div>
            </div>

            <div className="info_card">
              <img
                src="/assets/images/home/contacts/big_call.png"
                alt=""
                className="bg_icon"
              />
              <div className="info_content">
                <h6 className="info_label">Phone Number</h6>
                <p className="info_text">+91 8007008833</p>
              </div>
              <div className="icon_circle">
                <img
                  src="/assets/images/home/contacts/phone_call.png"
                  alt="Phone"
                  className="info_icon_img"
                />
              </div>
            </div>

            <div className="info_card">
              <img
                src="/assets/images/home/contacts/big_mail.png"
                alt=""
                className="bg_icon"
              />
              <div className="info_content">
                <h6 className="info_label">Email</h6>
                <p className="info_text">info@gravitydrive.in</p>
              </div>
              <div className="icon_circle">
                <img
                  src="/assets/images/home/contacts/mail.png"
                  alt="Email"
                  className="info_icon_img"
                />
              </div>
            </div>
          </div>

          <div className="contact_form form">
            <Form onSubmit={handleSubmit(onSubmit)}>
              {/* Name */}
              <Form.Group className="input_group">
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Enter you Full name"
                  {...register("name", {
                    required: "Name is required",
                  })}
                  className={classNames("", {
                    "is-valid": getValues("name"),
                  })}
                />
                {errors?.name && (
                  <span className="invalid-feedback d-block">
                    {errors.name.message}
                  </span>
                )}
              </Form.Group>

              {/* Email */}
              <Form.Group className="input_group">
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Enter you email address"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Invalid email address",
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.email,
                    "is-valid": getValues("email"),
                  })}
                />
                {errors?.email && (
                  <span className="invalid-feedback d-block">
                    {errors.email.message}
                  </span>
                )}
              </Form.Group>

              {/* Message */}
              <Form.Group className="input_group">
                <Form.Control
                  as="textarea"
                  name="message"
                  placeholder="Enter your message"
                  rows={4}
                  {...register("message", {
                    required: "Message is required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.message,
                    "is-valid": getValues("message"),
                  })}
                />
                {errors?.message && (
                  <span className="invalid-feedback d-block">
                    {errors.message.message}
                  </span>
                )}
              </Form.Group>

              {/* Submit Button */}
              <div className="send_btn_div">
                <Arrow_Btn
                  btnText="Send Message"
                  type="submit"
                  // onClick={() => {
                  //   setShowModal(true);
                  //   setTimeout(() => {
                  //     setShowModal(false);
                  //     navigate("/");
                  //   }, 2500);
                  // }}
                />
              </div>
            </Form>
          </div>
        </div>
      </div>
      <Fullscreen_Success_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        lottie={<Message_Lottie />}
        message="Message Sent!"
      />
    </section>
  );
};

export default Contacts;
